import api from '../api/apiClient';

const unwrap = (response) => response?.data ?? response;

class ImplementationChecklistService {
  async getGlobalUnified(analysisId) {
    try {
      const response = await api.get(`/implementation-checklist/${analysisId}/global-unified`);
      const data = unwrap(response);
      return { success: true, data };
    } catch (error) {
      console.error('[ImplementationChecklistService] getGlobalUnified error:', error);
      return { success: false, error: error.message };
    }
  }

  async generateQuestions(analysisId, payload) {
    try {
      const response = await api.post(`/implementation-checklist/${analysisId}/generate-questions`, payload);
      return { success: true, data: unwrap(response) };
    } catch (error) {
      console.error('[ImplementationChecklistService] generateQuestions error:', error);
      return { success: false, error: error.message };
    }
  }

  async saveResponsesGlobal(analysisId, payload) {
    try {
      const response = await api.post(`/implementation-checklist/${analysisId}/save-responses`, payload);
      return { success: true, data: unwrap(response) };
    } catch (error) {
      console.error('[ImplementationChecklistService] saveResponsesGlobal error:', error);
      return { success: false, error: error.message };
    }
  }

  async saveResponsible(analysisId, payload) {
    try {
      const response = await api.post(`/implementation-checklist/${analysisId}/responsible/save`, payload);
      return { success: true, data: unwrap(response) };
    } catch (error) {
      console.error('[ImplementationChecklistService] saveResponsible error:', error);
      return { success: false, error: error.message };
    }
  }

  async approveResponsible(analysisId, payload) {
    try {
      const response = await api.post(`/implementation-checklist/${analysisId}/responsible/approve`, payload);
      return { success: true, data: unwrap(response) };
    } catch (error) {
      console.error('[ImplementationChecklistService] approveResponsible error:', error);
      return { success: false, error: error.message };
    }
  }
}

const implementationChecklistService = new ImplementationChecklistService();
export default implementationChecklistService;
